import { render, staticRenderFns } from "./DashboardTvMensal.vue?vue&type=template&id=53863c00"
import script from "./DashboardTvMensal.vue?vue&type=script&lang=ts"
export * from "./DashboardTvMensal.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTvMensal.vue?vue&type=style&index=0&id=53863c00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports